// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__yw0k7","calendarButtons":"ClockData_calendarButtons__1eZT8"};